import './AlertsSidePanel.scss';
import AlertsSidePanel from './AlertsSidePanel';

export default AlertsSidePanel;
